// export class OwnDeposit {
//     availableBalance: 0;
//     balance: 0;
//     blockedAmount: 0;
//     branchName: '';
//     depositIban: '';
//     depositNumber: '';
//     depositOwnerType: 'ACTUAL';
//     depositType: '';
//     expireDate: '2020-05-13T06:30:49.435Z';
//     inaugurationDate: '2020-05-13T06:30:49.435Z';
//     title: '';
//     uniqueId: '';
//     visible: true;
//     constructor() {}
// }


export enum DepositWithdrawalOption {
    NONE = 'NONE', // غیرقابل برداشت
    MASHRUT = 'MASHRUT', // قابل برداشت مشروط
    BE_TANHAYEE = 'BE_TANHAYEE', // قابل برداشت به تنهایی
    UNKNOWN = 'UNKNOWN'
}
export enum DepositOwnerType {
    LEGAL = 'LEGAL', // حقوقی
    SHARED = 'SHARED', // مشترک
    ACTUAL = 'ACTUAL' // حقیقی
}

export class DepositType {
    availableBalance: number;
    balance: number;
    blockedAmount: number;
    branchName: string;
    depositIban: string;
    depositNumber: string;
    depositOwnerType: DepositOwnerType;
    depositType: string;
    expireDate;
    inaugurationDate: number;
    order: number;
    title: string;
    uniqueId: string;
    visible: boolean;
    depositWithdrawalOption: DepositWithdrawalOption;
}
export enum RulesType {
  SatnaInterBankTransfer = 'ساتنا' ,
  PayaInterBankTransfer = 'پایا',
  PolInterBankTransfer = 'پل'
}
export class Rules {
  active: boolean;
  description: string;
  interBankTransactionType: string;
  maxAmount: number;
  minAmount: number;
}
